<template>
<div >
    <v-toolbar flat color="white">
        <v-btn color="primary" dark class="mb-2" @click="newDialog=true;basicInformation=true; showAccessPointGroups=false; cancelFields()" round >ADD TAG</v-btn>
        <v-spacer></v-spacer>
        <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        max-width="50px"
        class="pa-3"
        clearable
      ></v-text-field>
    
    </v-toolbar>

  <v-dialog persistent v-if="accessPointGroupSearch" v-model="accessPointGroupSearch" max-width="1000px">
      <accesspointgroupsearchmodal
           @accessPointGroupSelected="onAccessPointGroupSelection"
           :multi="true"
           :preselected="selectedAccessPointGroups"
      ></accesspointgroupsearchmodal>
    </v-dialog>

     <v-dialog persistent v-model="contactSearch" max-width="1000px">
      <contactsearchmodal
           @contactSelected="onContactSelection"
      ></contactsearchmodal>
    </v-dialog>


     <!-- Add new item modal -->
    <v-dialog persistent v-model="newDialog" max-width="750px">

        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >ADD TAG</h1>
        </v-toolbar>

          <v-toolbar flat color="white" v-if="typeof(this.$route.params.accessPointGroupId) == 'undefined'">
        <v-tabs >
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab
            @click="basicInformation=true;showAccessPointGroups=false"
            class="grey--text"
            flat
            round
            color="grey"
          >Basic Information</v-tab>
          <v-tab
            @click="basicInformation=false;showAccessPointGroups=true"
            class="grey--text"
            flat
            round
            color="grey"
          >Access Point Groups</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card flat>
        <v-card flat v-show="basicInformation">
          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>

                <v-flex xs12 sm6 md6>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.tagCode"
                    label="Tag Code"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                 <v-flex xs12 sm6 md6
                    v-if="this.selectedContact==null && (typeof(this.contactId) == 'undefined')">
                    <v-btn @click="contactSearch=true; selectedContact={}" flat color="primary">Add Contact</v-btn>
                  </v-flex>

                  <v-flex xs12 sm6 md6
                    v-if="this.selectedContact!=null&& (typeof(this.contactId) == 'undefined')">
                    <v-text-field v-if="this.selectedContact!=null&& (typeof(this.contactId) == 'undefined')" v-model="selectedContact.name" disabled></v-text-field>
                    <v-btn v-if="(typeof(this.contactId) == 'undefined')" flat color="primary" @click="contactSearch=true">Edit Contact</v-btn>
                  </v-flex>

                 <v-flex xs12 sm6 md6>
                 <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                    :items="tagCategories"
                    item-text="name"
                    item-value="id"
                    v-model="editedItem.tagCategoryId"  label="*Tag Category" >
               </v-autocomplete>
                </v-flex> 

                  <v-flex xs12 sm6 md6>
                 <v-menu :close-on-content-click='false'>
                  <v-text-field
                    :value="this.editedItem.expiryDate"
                    slot="activator"
                    required
                    label="Expiry Date"
                    prepend-icon="date_range"
                  ></v-text-field>
                  <v-date-picker v-model="editedItem.expiryDate"
                  :min="this.minimumDate"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm6 md6>
                  <v-switch v-model="editedItem.isActiveTag"  label="Active Tag"></v-switch>
                </v-flex>

                 <v-flex xs12 sm6 md6>
                  <v-switch v-model="editedItem.isBiometric"  label="Biometric Input"></v-switch>
                </v-flex>

                 <v-flex xs12 sm6 md6>
                  <v-switch v-model="editedItem.blackList"  label="Black List"></v-switch>
                </v-flex>

               </v-layout>
            </v-container>
          </v-card-text>
           </v-card>

        <v-card flat v-show="showAccessPointGroups">
          <v-card-text>
            <v-toolbar flat class="white">
              <v-spacer></v-spacer>
             
              <v-btn  v-if="this.selectedAccessPointGroups.length==0" 
                class="primary" flat round
                @click="accessPointGroupSearch=true ; selectedAccessPointGroups=[]"
              >Add Access Point Groups</v-btn>
                   <v-btn v-if="this.selectedAccessPointGroups.length>0" flat round class="primary" @click="accessPointGroupSearch=true ">Edit Access Point Groups</v-btn>          
            </v-toolbar>
            <v-data-table  v-if="this.selectedAccessPointGroups.length>0" 
              :headers="headers2"
              :items="selectedAccessPointGroups"
              item-key="id"
            >
              <template v-slot:items="props">
                <td class="text-xs-center">{{props.item.name}}</td>
                <td class="text-xs-center">{{props.item.description}}</td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

          <v-card-actions>
            <v-spacer></v-spacer>
            <small>*indicates required field</small>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="saveNew">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Edit Modal -->
    <v-dialog persistent v-model="dialog" max-width="750px">

        <v-toolbar flat class="primary">
        <h1 class="headline white--text" >EDIT TAG</h1>
        </v-toolbar>

          <v-toolbar flat color="white" v-if="typeof(this.$route.params.accessPointGroupId) == 'undefined'">
        <v-tabs >
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab
            @click="basicInformation=true;showAccessPointGroups=false"
            class="grey--text"
            flat
            round
            color="grey"
          >Basic Information</v-tab>
          <v-tab
            @click="basicInformation=false;showAccessPointGroups=true"
            class="grey--text"
            flat
            round
            color="grey"
          >Access Point Groups</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card flat>
        <v-card flat v-show="basicInformation">
          <v-card-text>
            <v-container grid-list-xs>
              <v-layout wrap>
            
                <v-flex xs12 sm6 md6>
                  <v-text-field
                    prepend-icon="edit"
                    v-model="editedItem.tagCode"
                    label="Tag Code"
                    required
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                  <v-flex xs12 sm6 md6 v-if="(typeof(this.contactId) == 'undefined')">
                    <v-text-field v-if="this.selectedContact!=null&& (typeof(this.contactId) == 'undefined')" v-model="selectedContact.name" disabled></v-text-field>
                    <v-btn flat color="primary" @click="contactSearch=true">Edit Contact</v-btn>
                  </v-flex>

                 <v-flex xs12 sm6 md6>
                 <v-autocomplete
                 clearable
                  hide-no-data
                  flat
                  color="primary"
                    :items="tagCategories"
                    item-text="name"
                    item-value="id"
                    v-model="editedItem.tagCategoryId"  label="*Tag Category" >
                </v-autocomplete>        
                </v-flex> 

                  <v-flex xs12 sm6 md6>
                  <v-menu :close-on-content-click='false'>
                  <v-text-field
                    :value="this.editedItem.expiryDate"
                    slot="activator"
                    required
                    label="Expiry Date"
                    prepend-icon="date_range"
                  ></v-text-field>
                  <v-date-picker v-model="editedItem.expiryDate"
                    :min="this.minimumDate"></v-date-picker>
                </v-menu>
              </v-flex>

               <v-flex xs12 sm6 md6>
                  <v-switch v-model="editedItem.isActiveTag"  label="Active Tag"></v-switch>
                </v-flex>

                 <v-flex xs12 sm6 md6>
                  <v-switch v-model="editedItem.isBiometric"  label="Biometric Input"></v-switch>
                </v-flex>

                 <v-flex xs12 sm6 md6>
                  <v-switch v-model="editedItem.blackList"  label="Black List"></v-switch>
                </v-flex>

              </v-layout>
            </v-container>
          </v-card-text>
            </v-card>

        <v-card flat v-show="showAccessPointGroups">
          <v-card-text>
            <v-toolbar flat class="white">
              <v-spacer></v-spacer>
             
              <v-btn  v-if="this.selectedAccessPointGroups.length==0" 
                class="primary" flat round
                @click="accessPointGroupSearch=true ; selectedAccessPointGroups=[]"
              >Add Access Point Groups</v-btn>
                   <v-btn v-if="this.selectedAccessPointGroups.length>0" flat round class="primary" @click="accessPointGroupSearch=true ">Edit Access Point Groups</v-btn>          
            </v-toolbar>
            <v-data-table  v-if="this.selectedAccessPointGroups.length>0" 
              :headers="headers2"
              :items="selectedAccessPointGroups"
              item-key="id"
            >
              <template v-slot:items="props">
                <td class="text-xs-center">{{props.item.name}}</td>
                <td class="text-xs-center">{{props.item.description}}</td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>


          <v-card-actions>
            <v-spacer></v-spacer>
            <small>*indicates required field</small>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save" >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :expand="expand"
      :pagination.sync="pagination"
      :loading="isloading"
      :items="tags"
      :rows-per-page-items="[10, 25, 50, 100]"
      item-key="name"
      align-center
    >
      <template v-slot:items="props" >
          <td class="justify-center layout px-0">
            <v-icon small class="mr-2" @click="basicInformation=true; showAccessPointGroups=false; editItem(props.item)">edit</v-icon>
            <v-icon small @click="deleteItem(props.item.id)">delete</v-icon>
          </td>
          <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.tagCode}}</td>
            <!-- <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.biometricImage}}</td> -->
            <td @click="routerLinkToDetails(props.item)" class="text-xs-center" v-if="props.item.contact !== null">{{props.item.contact.name}} {{props.item.contact.surname}}</td>
            <td @click="routerLinkToDetails(props.item)" class="text-xs-center" v-else>No contact associated</td>
           <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.tagCategory.name}}</td> 
           <td @click="routerLinkToDetails(props.item)" class="text-xs-center">{{props.item.expiryDate}}</td> 
           <td @click="routerLinkToDetails(props.item)" class="text-xs-center" v-if="props.item.isActiveTag===false">Passive Tag</td>
          <td @click="routerLinkToDetails(props.item)" class="text-xs-center" v-else>Active Tag</td>
             <td @click="routerLinkToDetails(props.item)" class="text-xs-center" v-if="props.item.blackList===false"><v-chip small :class="`Active white--text caption my-2`">Not Black Listed</v-chip></td>
          <td @click="routerLinkToDetails(props.item)" class="text-xs-center" v-else><v-chip small :class="`Inactive white--text caption my-2`">Black Listed</v-chip></td>

      </template>
      <!-- Custom Row count and Paging text -->
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      <!-- No data Dispalay -->
    
    </v-data-table>
  </div>
</template>
 
<script>
import Api from "@/services/Api";
import ContactSearchModal from "@/components/contactSearchModal.vue";
import AccessPointGroupSearchModal from "@/components/AccessPointGroupSearchModal.vue";
export default {
    props:["tagscomponent",
          "accessPointGroupId" , 'tagsinfo', 'contactId'
                 ],
    components: {
    contactsearchmodal: ContactSearchModal,
    accesspointgroupsearchmodal: AccessPointGroupSearchModal
  },
  data() {
    return {
    showAccessPointGroups: false,
    basicInformation: false,
    selectedAccessPointGroups: [],
    accessPointGroupSearch: false,
    selectedContact: null,
    contactSearch: false,
    minimumDate: "",
    showDetails: true,
    isloading:true,
    loading: false, 
    expand: false,
    search: "",
    dialog: false,
    newDialog: false,
    pagination: { },
     headers2: [
      {
        text: "Name",
        align: "center",
        value: "name"
      },
      {
        text: "Description",
        align: "center",
        value: "description"
      }
    ],
    headers: [
            {
        text: "Action",
        align: "center"
      },
      {
        text: "Tag Code",
        align: "center",
        value: "tagCode"
      },
      {
        text: "Contact",
        align: "center",
        value: "contact"
      },
      {
        text: "Tag Category",
        align: "center",
        value: "tagCategory"
      },
      {
        text: "Expiry Date",
        align: "center",
        value: "expiryDate"
      },
        {
        text: "Active/ Passive Tag",
        align: "center",
        value: "isActiveTag"
      },
      {
        text: "Black List",
        align: "center",
        value: "blackList"
      }
    ],
    tags: [],
    tagCategories: [],
    contacts:[],
    editedIndex: -1,
    editedItem: {
        tagCode: "",
        biometricImage: "",
        contactId: null,
        tagCategoryId: null, 
        expiryDate: "",
        isActiveTag: false,
        isBiometric: false,
        blackList: false,
        isDeleted: false
    },
    defaultItem: {
        tagCode: "",
        biometricImage: "",
        contactId: null,
        tagCategoryId: null, 
        expiryDate: "",
        isActiveTag: false,
        isBiometric: false,
        blackList: false,
        isDeleted: false
    },
  }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;
      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
      search(value){
       const route= {
        search: this.$route.search
      }
       if ((this.search)){      
        route.query = {search: this.search}        
      }
      this.$router.push(route)      
    
    },
    '$route.query':{
      immediate: true,
      async handler(value){
        this.tags= await this.searchTags(value)
      }
    },
     '$route.query.search':{
      immediate: true,
      handler(value){
        this.search=value
      },
    }, 
  },
  created() {
    this.initialize();
  },
  methods: {
      routerLinkToDetails(item) {
      this.editedItem = Object.assign({}, item);
      this.$router.push({ path: "/tagSummaryPage/" + this.editedItem.id });
    },
    cancelFields(){
          this.selectedAccessPointGroups =[],
          this.editedItem.tagCode="",
          this.editedItem.biometricImage="",
          this.selectedContact = null,
          this.editedItem.tagCategoryId = null,
          this.editedItem.expiryDate="",
          this.editedItem.isActiveTag=false, 
          this.editedItem.isBiometric=false, 
          this.editedItem.blackList=false   
      },
       onAccessPointGroupSelection(e){
      this.selectedAccessPointGroups = e
      this.accessPointGroupSearch = false
    },
    onContactSelection(e){
      this.selectedContact = e
      this.contactSearch = false
    },
     searchTags(search){       
       if(typeof(this.accessPointGroupId)!= 'undefined' && this.accessPointGroupId != null) {        
          if(search.search!==""){  
             this.isloading =true
              Api()
               .get("/accessPointGroupTags/getTags/" + this.$route.params.accessPointGroupId,{
                 params: {
                 search: search.search,
                 }
              })         
              .then(response => {
                 this.tags = [];
                 for(let i=0; i< response.data.length; i++)
                 {
                   this.tags.push(response.data[i].tag)
                 }
             this.isloading =false
        });}
        }else if(typeof(this.contactId)!= 'undefined'){ 
                 Api()
                 .get('/tags/showByContact/' + this.contactId,{
                 params: {
                 search: search.search,
                 }
              })         
                 .then(response=>{
                    this.tags = [];
                      for(let i=0; i<response.data.length; i++){
                         this.tags.push(response.data[i])
                      }
                   })   
        } else {
          if(search.search!==""){      
        Api()
        .get('/tags/getall',{
          params: {
          search: search.search,
         }
          })
        .then(response=>{
          this.tags=response.data
          this.isloading =false
        })} 
        }
     
      },
    fetchTags() {
        this.isloading =true     
        if(typeof(this.accessPointGroupId)!= 'undefined' && this.accessPointGroupId != null) {
           Api()
        .get("/accessPointGroupTags/getTags/" + this.$route.params.accessPointGroupId)
        .then(response => {      
           this.tags = [];
           for(let i=0; i< response.data.length; i++)
                 {
                   this.tags.push(response.data[i].tag)
                 }
             this.isloading =false
        });
        }else if(typeof(this.contactId)!= 'undefined'){
      Api()
      .get('/tags/showByContact/' + this.contactId)
      .then(response=>{
        this.tags = [];
        for(let i=0; i<response.data.length; i++){
        this.tags.push(response.data[i])
        }
        this.isloading =false
      })
        } else {
            Api()
             .get("/tags/getall")
              .then(response => {
               this.tags = response.data;
               this.isloading =false
               });     
        }
    },
     fetchTagCategories() {
      Api()
        .get("/tagCategories/getall")
        .then(response => {
          this.tagCategories = response.data;
          this.isloading =false
        });      
    },
     fetchContacts() {
      Api()
        .get("/contacts/active")
        .then(response => {
          this.contacts = response.data;
          this.isloading =false
        });      
    },
    fetchMinimumDate() {
     this.minimumDate = new Date().toISOString().substr(0, 10)
    },
    initialize() {
      this.fetchTagCategories(); 
      this.fetchMinimumDate();    
      this.fetchContacts();
    },
    editItem(item) {
      this.selectedAccessPointGroups =[]
      this.editedIndex = this.tags.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.selectedContact = item.contact
      if(typeof(this.$route.params.accessPointGroupId) == 'undefined'){
       Api().get('/accessPointGroupTags/getAccessPointGroups/'+ this.editedItem.id).then(response=> {
       for(let i=0; i<response.data.length; i++){
           this.selectedAccessPointGroups.push(response.data[i].accessPointGroup)
         }
    })
      }
      this.dialog = true;
    },
      deleteItem(id) {
        let accessPointGroupTempId = this.$route.params.accessPointGroupId
       let tempTagId = id
      confirm("Are you sure you want to delete this item?") &&
      Api().put("/tags/" + id, {
          isDeleted: true
        }).then(response => {
               if(typeof(accessPointGroupTempId) != 'undefined'){
                 Api().get('accessPointGroupTags/getByGroupAndTag/' + accessPointGroupTempId + '/' + id)
                 .then(response=>{
                    Api().put('/accessPointGroupTags/' + response.data[0].id,{
                      isDeleted:true
                 })
                  this.fetchTags();
                  this.$emit('tagsSaved')
              })
         }else{
            this.fetchTags();
             this.$emit('tagsSaved')
         }
        })          
    },
    close() {
      this.dialog = false;
      this.newDialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
       let accessPointGrTag =[]
       let accessPointGroupList = []
       accessPointGrTag = this.editedItem.accessPointGroupTags
       accessPointGroupList = this.selectedAccessPointGroups
       let tempTagId = this.editedItem.id
       let proceed = true;
     if (this.editedItem.isBiometric == false && this.editedItem.tagCode == "") {
        proceed = false;
        confirm("Please enter a tag code.");
      }
      if (this.editedItem.tagCategoryId == null) {
        proceed = false;
        confirm("Please select a tag category.");
      }
      if (this.selectedContact == null && (typeof(this.contactId) == 'undefined')) {
        proceed = false;
        confirm("Please select a contact.");
      }    
       if (proceed == true && (typeof(this.contactId) == 'undefined') &&  (typeof(this.$route.params.accessPointGroupId) == 'undefined')) {
         //In Tag Page
        Api().put("/tags/" + this.editedItem.id, {
          tagCode: this.editedItem.tagCode,
          biometricImage: this.editedItem.biometricImage,    
          contactId: this.selectedContact.id,   
          tagCategoryId: this.editedItem.tagCategoryId,
          expiryDate: this.editedItem.expiryDate,
          isActiveTag: this.editedItem.isActiveTag, 
          isBiometric: this.editedItem.isBiometric, 
          blackList: this.editedItem.blackList,   
          isDeleted: this.editedItem.isDeleted
        }).then(response => {
         for(let l=0; l<accessPointGrTag.length; l++){          
          Api().put("/accessPointGroupTags/" + accessPointGrTag[l].id, {
               isDeleted:true
        })
        }
        }).then(response=>{
          for(let k=0; k<accessPointGroupList.length; k++){           
          Api().post("/accessPointGroupTags", {
                   accessPointGroupId: accessPointGroupList[k].id,
                   tagId: tempTagId
        })
        }
         this.$emit('tagsSaved')
         this.fetchTags();    
        }) 
         this.close();       
      } else if(proceed == true && (typeof(this.contactId) == 'undefined') &&  (typeof(this.$route.params.accessPointGroupId) != 'undefined')){
        //In Access Point Group Summary
        Api().put("/tags/" + this.editedItem.id, {
          tagCode: this.editedItem.tagCode,
          biometricImage: this.editedItem.biometricImage,    
          contactId: this.selectedContact.id,   
          tagCategoryId: this.editedItem.tagCategoryId,
          expiryDate: this.editedItem.expiryDate,
          isActiveTag: this.editedItem.isActiveTag, 
          isBiometric: this.editedItem.isBiometric, 
          blackList: this.editedItem.blackList,   
          isDeleted: this.editedItem.isDeleted
        }).then(response => {
         this.$emit('tagsSaved')
         this.fetchTags();    
        }) 
         this.close();       
      }
      else if(proceed == true && (typeof(this.contactId) != 'undefined')){
        //In Contact Summary
           Api().put("/tags/" + this.editedItem.id, {
          tagCode: this.editedItem.tagCode,
          biometricImage: this.editedItem.biometricImage,    
          contactId: this.contactId,   
          tagCategoryId: this.editedItem.tagCategoryId,
          expiryDate: this.editedItem.expiryDate,
          isActiveTag: this.editedItem.isActiveTag, 
          isBiometric: this.editedItem.isBiometric,
          blackList: this.editedItem.blackList,   
          isDeleted: this.editedItem.isDeleted
        }).then(response => {
         for(let i=0; i<accessPointGrTag.length; i++){           
          Api().put("/accessPointGroupTags/" + accessPointGrTag[i].id, {
               isDeleted:true
        })
        }
        }).then(response=>{
          for(let j=0; j<accessPointGroupList.length; j++){           
          Api().post("/accessPointGroupTags", {
                   accessPointGroupId: accessPointGroupList[j].id,
                   tagId: tempTagId
        })
        }
         this.$emit('tagsSaved')
         this.fetchTags();  
        })
         this.close();
      }
      },
      saveNew() {       
      let accessPointGroupTempList = this.selectedAccessPointGroups       
      let accessPointGroupTempId = this.$route.params.accessPointGroupId
        
      let proceed = true;
      if (this.editedItem.isBiometric == false && this.editedItem.tagCode == "") {
        proceed = false;
        confirm("Please enter a tag code.");
      }
      if (this.editedItem.tagCategoryId == null) {
        proceed = false;
        confirm("Please select a tag category.");
      }
      if (this.selectedContact == null && (typeof(this.contactId) == 'undefined')) {
        proceed = false;
        confirm("Please select a contact.");
      }    
       if ((typeof(accessPointGroupTempId) == 'undefined') && accessPointGroupTempList.length==0) {
        proceed = false;
        confirm("Please select an access point group.");
      }    
      if (proceed == true && (typeof(this.contactId) == 'undefined')) {
        Api().post("/tags", {
          tagCode: this.editedItem.tagCode,
          biometricImage: this.editedItem.biometricImage,    
          contactId: this.selectedContact.id,   
          tagCategoryId: this.editedItem.tagCategoryId,
          expiryDate: this.editedItem.expiryDate,
          isActiveTag: this.editedItem.isActiveTag, 
          isBiometric: this.editedItem.isBiometric,
          blackList: this.editedItem.blackList,   
          isDeleted: this.editedItem.isDeleted
        }).then(response => {
          let tempTagId = response.data.id
          if(typeof(accessPointGroupTempId) != 'undefined'){
            //In Access Point Group Summarry
             Api().post("/accessPointGroupTags", {
                   accessPointGroupId: accessPointGroupTempId,
                   tagId: tempTagId
        })
          }else if(typeof(accessPointGroupTempList) != 'undefined'){
            //In Tags Page
               for(let index=0; index <accessPointGroupTempList.length; index++){
                Api().post("/accessPointGroupTags", {
                   accessPointGroupId: accessPointGroupTempList[index].id,
                   tagId: tempTagId
        })
          }  
          }
          this.$emit('tagsSaved')
          this.fetchTags();
        })  ;this.close();     
        }else if(proceed == true && (typeof(this.contactId) != 'undefined')){
          //In Contact Summary
         Api().post("/tags", {
          tagCode: this.editedItem.tagCode,
          biometricImage: this.editedItem.biometricImage,    
          contactId: this.contactId,   
          tagCategoryId: this.editedItem.tagCategoryId,
          expiryDate: this.editedItem.expiryDate,
          isActiveTag: this.editedItem.isActiveTag, 
          isBiometric: this.editedItem.isBiometric,
          blackList: this.editedItem.blackList,   
          isDeleted: this.editedItem.isDeleted
        }).then(response => {
            let tempTagId = response.data.id
          if(typeof(accessPointGroupTempList) != 'undefined'){
               for(let i=0; i <accessPointGroupTempList.length; i++){
              Api().post("/accessPointGroupTags", {
                   accessPointGroupId: accessPointGroupTempList[i].id,
                   tagId: tempTagId
        })
          }  
          this.$emit('tagsSaved')
          this.fetchTags();
          }
        });   this.close();
    }
  }
  }
};
</script>